<template>
	<div id="Attend" class="attend">
		<attend-orders-component></attend-orders-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'

import AttendOrdersComponent from '@/components/AttendOrdersComponent.vue'
export default {
	name: 'Attend',
	mixins: [axiosAction, errors, mixin],
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Atención de Ordenes')
			this.setSubTitleModule('')
		},
	},
	components: {
		'attend-orders-component': AttendOrdersComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>